import { createContext } from 'react';

const loadedTabs = { '/employees': false, '/customers': false, '/offices': false, '/offices/internalhours': false, '/coverings': false }

export const initialState = {
    user: null,
    error: null,
    activeTab: '/',
    loadedTabs: loadedTabs,
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_SUCCESS':
            return {
                ...state,
                user: action.payload,
            };
        case 'OFFICE_FETCH_SUCCESS':
            return {
                ...state,
                offices: action.payload,
            };

        case 'FETCH_ERROR':
            return {
                ...state,
                error: action.payload,
                user: { id: 'User not found', isAuthenticated: false },
            };

        case 'ACTIVE_TAB':
            return {
                ...state,
                activeTab: action.payload,
            };

        case 'LOADED_TABS':
            return {
                ...state,
                loadedTabs: Object.assign(loadedTabs, { [action.path]: action.payload }),
            };
        case 'ACTIVE_TAB_AND_LOADED_TABS':
            return {
                ...state,
                activeTab: action.path,
                loadedTabs: Object.assign(loadedTabs, { [action.path]: action.payload }),
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);